<ng-template #dropdownButtonTemplate>
  <ng-container *ngIf="isCurrentCategoryFilterActive; else defaultButtonText">
    {{ appliedCategoryFilter.filter.text | i18n }}

    <span class="subcategory-count" *ngIf="appliedSubcategoryCount > 0">
      +{{ appliedSubcategoryCount }}
    </span>
  </ng-container>
  <ng-template #defaultButtonText>
    {{ 'filters.category.main.label' | i18n }}
  </ng-template>
</ng-template>

<ng-template #dropdownContentTemplate>
  <div class="category-filter">
    <lib-category-filter
      (update)="selectCategory($event)"
    ></lib-category-filter>
  </div>

  <div class="subcategory-filter" *ngIf="showSubcategoryFilter">
    <lib-subcategory-filter
      [categoryFilter]="currentCategoryFilter"
      (update)="selectSubcategories($event)"
    ></lib-subcategory-filter>
  </div>
</ng-template>

<ng-template #applyButtonTemplate let-close="close">
  <button class="filter-apply-button" (click)="applyChanges(); close()">
    {{ 'common.apply' | i18n }}
  </button>
</ng-template>

<app-filter-dropdown
  [preferredWidth]="271"
  [maxHeight]="562"
  [dropdownButtonTemplate]="dropdownButtonTemplate"
  [dropdownContentTemplate]="dropdownContentTemplate"
  [applyButtonTemplate]="applyButtonTemplate"
  [hasValue]="isCurrentCategoryFilterActive"
  (clear)="reset()"
>
</app-filter-dropdown>
